import { tokens } from "../../theme";

export const mockTransactions = [
  {
    txId: "01e4dsa",
    user: "johndoe",
    date: "2021-09-01",
    cost: "55,000"
  },
  {
    txId: "0315dsaa",
    user: "jackdower",
    date: "2022-04-01",
    cost: "35,000"
  },
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "18,000"
  },
  {
    txId: "51034szv",
    user: "goodmanave",
    date: "2022-11-05",
    cost: "200,000"
  },
  {
    txId: "0a123sb",
    user: "stevebower",
    date: "2022-11-02",
    cost: "55,000"
  },
  {
    txId: "01e4dsa",
    user: "aberdohnny",
    date: "2021-09-01",
    cost: "30,000"
  },
  {
    txId: "120s51a",
    user: "wootzifer",
    date: "2019-04-15",
    cost: "24,000"
  },
  {
    txId: "0315dsaa",
    user: "jackdower",
    date: "2022-04-01",
    cost: "133,000"
  }
];

export const mockBarData = [
  {
    country: "AD",
    mobile: 100,
    mobileColor: "hsl(229, 70%, 50%)",
    webapp: 60,
    webappColor: "hsl(204, 70%, 72%)",
    design: 96,
    designColor: "hsl(296, 70%, 50%)",
    desktop: 28,
    desktopColor: "hsl(37, 90%, 71%)",
    others: 72,
    othersColor: "hsl(97, 70%, 50%)",
    website: 40,
    websiteColor: "hsl(340, 70%, 50%)"
  },
  {
    country: "AE",
    mobile: 55,
    mobileColor: "hsl(307, 70%, 50%)",
    webapp: 60,
    webappColor: "hsl(204, 70%, 72%)",
    design: 28,
    designColor: "hsl(111, 70%, 50%)",
    desktop: 50,
    desktopColor: "hsl(37, 90%, 71%)",
    others: 58,
    othersColor: "hsl(273, 70%, 50%)",
    website: 29,
    websiteColor: "hsl(275, 70%, 50%)"
  },
  {
    country: "AF",
    mobile: 109,
    mobileColor: "hsl(72, 70%, 50%)",
    webapp: 60,
    webappColor: "hsl(204, 70%, 72%)",
    design: 23,
    designColor: "hsl(96, 70%, 50%)",
    desktop: 28,
    desktopColor: "hsl(37, 90%, 71%)",
    others: 34,
    othersColor: "hsl(106, 70%, 50%)",
    website: 152,
    websiteColor: "hsl(256, 70%, 50%)"
  },
  {
    country: "AG",
    mobile: 133,
    mobiledogColor: "hsl(257, 70%, 50%)",
    webapp: 60,
    webappColor: "hsl(204, 70%, 72%)",
    design: 52,
    designColor: "hsl(326, 70%, 50%)",
    desktop: 128,
    desktopColor: "hsl(37, 90%, 71%)",
    others: 43,
    othersColor: "hsl(110, 70%, 50%)",
    website: 83,
    websiteColor: "hsl(9, 70%, 50%)"
  },
  {
    country: "AI",
    mobile: 81,
    mobileColor: "hsl(190, 70%, 50%)",
    webapp: 60,
    webappColor: "hsl(204, 70%, 72%)",
    design: 80,
    designColor: "hsl(325, 70%, 50%)",
    desktop: 28,
    desktopColor: "hsl(37, 90%, 71%)",
    others: 112,
    othersColor: "hsl(54, 70%, 50%)",
    website: 35,
    websiteColor: "hsl(285, 70%, 50%)"
  },
  {
    country: "AL",
    mobile: 66,
    mobileColor: "hsl(208, 70%, 50%)",
    webapp: 60,
    webappColor: "hsl(204, 70%, 72%)",
    design: 111,
    designColor: "hsl(334, 70%, 50%)",
    desktop: 88,
    desktopColor: "hsl(37, 90%, 71%)",
    others: 167,
    othersColor: "hsl(182, 70%, 50%)",
    website: 18,
    websiteColor: "hsl(76, 70%, 50%)"
  },
  {
    country: "AM",
    mobile: 80,
    mobileColor: "hsl(87, 70%, 50%)",
    webapp: 60,
    webappColor: "hsl(204, 70%, 72%)",
    design: 47,
    designColor: "hsl(141, 70%, 50%)",
    desktop: 28,
    desktopColor: "hsl(37, 90%, 71%)",
    others: 108,
    othersColor: "hsl(224, 70%, 50%)",
    website: 49,
    websiteColor: "hsl(274, 70%, 50%)"
  }
];

export const mockLineData = [
  {
    id: "US",
    color: tokens("dark").greenAccent[500],
    data: [
      {
        x: "e-learning",
        y: 101
      },
      {
        x: "logistics",
        y: 75
      },
      {
        x: "e-commerce",
        y: 36
      },
      {
        x: "financials",
        y: 216
      },
      {
        x: "hr",
        y: 236
      },
      {
        x: "portfolio",
        y: 88
      },
      {
        x: "healthcare",
        y: 200
      },
      {
        x: "lgu",
        y: 1
      },
      {
        x: "others",
        y: 14
      }
    ]
  },
  {
    id: "Europe",
    color: tokens("dark").blueAccent[300],
    data: [
      {
        x: "e-learning",
        y: 212
      },
      {
        x: "logistics",
        y: 190
      },
      {
        x: "e-commerce",
        y: 270
      },
      {
        x: "financials",
        y: 9
      },
      {
        x: "hr",
        y: 175
      },
      {
        x: "portfolio",
        y: 33
      },
      {
        x: "healthcare",
        y: 189
      },
      {
        x: "lgu",
        y: 87
      },
      {
        x: "others",
        y: 251
      }
    ]
  },
  {
    id: "Philippines",
    color: tokens("dark").redAccent[200],
    data: [
      {
        x: "e-learning",
        y: 191
      },
      {
        x: "logistics",
        y: 136
      },
      {
        x: "e-commerce",
        y: 91
      },
      {
        x: "financials",
        y: 190
      },
      {
        x: "hr",
        y: 152
      },
      {
        x: "portfolio",
        y: 189
      },
      {
        x: "healthcare",
        y: 152
      },
      {
        x: "lgu",
        y: 197
      },
      {
        x: "others",
        y: 170
      }
    ]
  }
];

export const mockGeographyData = [
  {
    id: "AFG",
    value: 520600
  },
  {
    id: "AGO",
    value: 949905
  },
  {
    id: "ALB",
    value: 329910
  },
  {
    id: "ARE",
    value: 675484
  },
  {
    id: "ARG",
    value: 432239
  },
  {
    id: "ARM",
    value: 288305
  },
  {
    id: "ATA",
    value: 415648
  },
  {
    id: "ATF",
    value: 665159
  },
  {
    id: "AUT",
    value: 798526
  },
  {
    id: "AZE",
    value: 481678
  },
  {
    id: "BDI",
    value: 496457
  },
  {
    id: "BEL",
    value: 252276
  },
  {
    id: "BEN",
    value: 440315
  },
  {
    id: "BFA",
    value: 343752
  },
  {
    id: "BGD",
    value: 920203
  },
  {
    id: "BGR",
    value: 261196
  },
  {
    id: "BHS",
    value: 421551
  },
  {
    id: "BIH",
    value: 974745
  },
  {
    id: "BLR",
    value: 349288
  },
  {
    id: "BLZ",
    value: 305983
  },
  {
    id: "BOL",
    value: 430840
  },
  {
    id: "BRN",
    value: 345666
  },
  {
    id: "BTN",
    value: 649678
  },
  {
    id: "BWA",
    value: 319392
  },
  {
    id: "CAF",
    value: 722549
  },
  {
    id: "CAN",
    value: 332843
  },
  {
    id: "CHE",
    value: 122159
  },
  {
    id: "CHL",
    value: 811736
  },
  {
    id: "CHN",
    value: 593604
  },
  {
    id: "CIV",
    value: 143219
  },
  {
    id: "CMR",
    value: 630627
  },
  {
    id: "COG",
    value: 498556
  },
  {
    id: "COL",
    value: 660527
  },
  {
    id: "CRI",
    value: 60262
  },
  {
    id: "CUB",
    value: 177870
  },
  {
    id: "-99",
    value: 463208
  },
  {
    id: "CYP",
    value: 945909
  },
  {
    id: "CZE",
    value: 500109
  },
  {
    id: "DEU",
    value: 63345
  },
  {
    id: "DJI",
    value: 634523
  },
  {
    id: "DNK",
    value: 731068
  },
  {
    id: "DOM",
    value: 262538
  },
  {
    id: "DZA",
    value: 760695
  },
  {
    id: "ECU",
    value: 301263
  },
  {
    id: "EGY",
    value: 148475
  },
  {
    id: "ERI",
    value: 939504
  },
  {
    id: "ESP",
    value: 706050
  },
  {
    id: "EST",
    value: 977015
  },
  {
    id: "ETH",
    value: 461734
  },
  {
    id: "FIN",
    value: 22800
  },
  {
    id: "FJI",
    value: 18985
  },
  {
    id: "FLK",
    value: 64986
  },
  {
    id: "FRA",
    value: 447457
  },
  {
    id: "GAB",
    value: 669675
  },
  {
    id: "GBR",
    value: 757120
  },
  {
    id: "GEO",
    value: 158702
  },
  {
    id: "GHA",
    value: 893180
  },
  {
    id: "GIN",
    value: 877288
  },
  {
    id: "GMB",
    value: 724530
  },
  {
    id: "GNB",
    value: 387753
  },
  {
    id: "GNQ",
    value: 706118
  },
  {
    id: "GRC",
    value: 377796
  },
  {
    id: "GTM",
    value: 66890
  },
  {
    id: "GUY",
    value: 719300
  },
  {
    id: "HND",
    value: 739590
  },
  {
    id: "HRV",
    value: 929467
  },
  {
    id: "HTI",
    value: 538961
  },
  {
    id: "HUN",
    value: 146095
  },
  {
    id: "IDN",
    value: 490681
  },
  {
    id: "IND",
    value: 549818
  },
  {
    id: "IRL",
    value: 630163
  },
  {
    id: "IRN",
    value: 596921
  },
  {
    id: "IRQ",
    value: 767023
  },
  {
    id: "ISL",
    value: 478682
  },
  {
    id: "ISR",
    value: 963688
  },
  {
    id: "ITA",
    value: 393089
  },
  {
    id: "JAM",
    value: 83173
  },
  {
    id: "JOR",
    value: 52005
  },
  {
    id: "JPN",
    value: 199174
  },
  {
    id: "KAZ",
    value: 181424
  },
  {
    id: "KEN",
    value: 60946
  },
  {
    id: "KGZ",
    value: 432478
  },
  {
    id: "KHM",
    value: 254461
  },
  {
    id: "OSA",
    value: 942447
  },
  {
    id: "KWT",
    value: 414413
  },
  {
    id: "LAO",
    value: 448339
  },
  {
    id: "LBN",
    value: 620090
  },
  {
    id: "LBR",
    value: 435950
  },
  {
    id: "LBY",
    value: 75091
  },
  {
    id: "LKA",
    value: 595124
  },
  {
    id: "LSO",
    value: 483524
  },
  {
    id: "LTU",
    value: 867357
  },
  {
    id: "LUX",
    value: 689172
  },
  {
    id: "LVA",
    value: 742980
  },
  {
    id: "MAR",
    value: 236538
  },
  {
    id: "MDA",
    value: 926836
  },
  {
    id: "MDG",
    value: 840840
  },
  {
    id: "MEX",
    value: 353910
  },
  {
    id: "MKD",
    value: 505842
  },
  {
    id: "MLI",
    value: 286082
  },
  {
    id: "MMR",
    value: 915544
  },
  {
    id: "MNE",
    value: 609500
  },
  {
    id: "MNG",
    value: 410428
  },
  {
    id: "MOZ",
    value: 32868
  },
  {
    id: "MRT",
    value: 375671
  },
  {
    id: "MWI",
    value: 591935
  },
  {
    id: "MYS",
    value: 991644
  },
  {
    id: "NAM",
    value: 701897
  },
  {
    id: "NCL",
    value: 144098
  },
  {
    id: "NER",
    value: 312944
  },
  {
    id: "NGA",
    value: 862877
  },
  {
    id: "NIC",
    value: 90831
  },
  {
    id: "NLD",
    value: 281879
  },
  {
    id: "NOR",
    value: 224537
  },
  {
    id: "NPL",
    value: 322331
  },
  {
    id: "NZL",
    value: 86615
  },
  {
    id: "OMN",
    value: 707881
  },
  {
    id: "PAK",
    value: 158577
  },
  {
    id: "PAN",
    value: 738579
  },
  {
    id: "PER",
    value: 248751
  },
  {
    id: "PHL",
    value: 557292
  },
  {
    id: "PNG",
    value: 516874
  },
  {
    id: "POL",
    value: 682137
  },
  {
    id: "PRI",
    value: 957399
  },
  {
    id: "PRT",
    value: 846430
  },
  {
    id: "PRY",
    value: 720555
  },
  {
    id: "QAT",
    value: 478726
  },
  {
    id: "ROU",
    value: 259318
  },
  {
    id: "RUS",
    value: 268735
  },
  {
    id: "RWA",
    value: 136781
  },
  {
    id: "ESH",
    value: 151957
  },
  {
    id: "SAU",
    value: 111821
  },
  {
    id: "SDN",
    value: 927112
  },
  {
    id: "SDS",
    value: 966473
  },
  {
    id: "SEN",
    value: 158085
  },
  {
    id: "SLB",
    value: 178389
  },
  {
    id: "SLE",
    value: 528433
  },
  {
    id: "SLV",
    value: 353467
  },
  {
    id: "ABV",
    value: 251
  },
  {
    id: "SOM",
    value: 445243
  },
  {
    id: "SRB",
    value: 202402
  },
  {
    id: "SUR",
    value: 972121
  },
  {
    id: "SVK",
    value: 319923
  },
  {
    id: "SVN",
    value: 728766
  },
  {
    id: "SWZ",
    value: 379669
  },
  {
    id: "SYR",
    value: 16221
  },
  {
    id: "TCD",
    value: 101273
  },
  {
    id: "TGO",
    value: 498411
  },
  {
    id: "THA",
    value: 506906
  },
  {
    id: "TJK",
    value: 613093
  },
  {
    id: "TKM",
    value: 327016
  },
  {
    id: "TLS",
    value: 607972
  },
  {
    id: "TTO",
    value: 936365
  },
  {
    id: "TUN",
    value: 898416
  },
  {
    id: "TUR",
    value: 237783
  },
  {
    id: "TWN",
    value: 878213
  },
  {
    id: "TZA",
    value: 442174
  },
  {
    id: "UGA",
    value: 720710
  },
  {
    id: "UKR",
    value: 74172
  },
  {
    id: "URY",
    value: 753177
  },
  {
    id: "USA",
    value: 658725
  },
  {
    id: "UZB",
    value: 550313
  },
  {
    id: "VEN",
    value: 707492
  },
  {
    id: "VNM",
    value: 538907
  },
  {
    id: "VUT",
    value: 650646
  },
  {
    id: "PSE",
    value: 476078
  },
  {
    id: "YEM",
    value: 957751
  },
  {
    id: "ZAF",
    value: 836949
  },
  {
    id: "ZMB",
    value: 714503
  },
  {
    id: "ZWE",
    value: 405217
  },
  {
    id: "KOR",
    value: 171135
  }
];

export const mockPieData = [
  {
    id: "financials",
    label: "financials",
    value: 239,
    color: "hsl(104, 70%, 50%)"
  },
  
  {
    id: "ecommerce",
    label: "ecommerce",
    value: 648,
    color: "hsl(344, 70%, 50%)"
  },
  {
    id: "logistics",
    label: "logistics",
    value: 503,
    color: "hsl(229, 70%, 50%)"
  },
  {
    id: "elearning",
    label: "elearning",
    value: 322,
    color: "hsl(291, 70%, 50%)"
  },

  {
    id: "hr",
    label: "hr",
    value: 175,
    color: "hsl(162, 70%, 50%)"
  }
];
